import React from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import type { KioskScanLayout } from "../kioskLayout"
import KioskPreviewScanCameraPlaceholder from "./KioskPreviewScanCameraPlaceholder"

type Props = {
  layout: KioskScanLayout
  scanLabel: string
  /** Fitted scan-label font size (px) — measured once by the device wrapper. */
  labelFontPx: number
}

/**
 * "Scan QR Code" label stacked above the camera box, the group vertically centered in the
 * scan area (positions come from the spec layout, px).
 */
const KioskPreviewScanScene = ({ layout, scanLabel, labelFontPx }: Props) => {
  const { group, camera } = layout

  return (
    <Flex
      position="absolute"
      top={`${group.top}px`}
      left="50%"
      transform="translateX(-50%)"
      w={`${group.width}px`}
      direction="column"
      align="center"
    >
      <Text
        fontSize={`${labelFontPx}px`}
        fontWeight="normal"
        color="white"
        lineHeight={1.1}
        textAlign="center"
        noOfLines={2}
        mb={`${group.labelGap}px`}
      >
        {scanLabel}
      </Text>
      <Box>
        <KioskPreviewScanCameraPlaceholder layout={camera} />
      </Box>
    </Flex>
  )
}

export default KioskPreviewScanScene
